import { Page } from '@/structure'
import { useTranslation } from 'react-i18next'
import InfoRectangle from '../components/common/InfoRectangle'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { Typography } from 'antd'
import { UPLOAD_ROUTE_PATH } from '../App'
const { Title } = Typography

const Welcome = () => {
  const { t } = useTranslation()
  return (
    <Page>
      <Title>{t('Welcome.WelcomeToGRIN')}</Title>
      <InfoRectangle img="images/common/thumb_up.webp">
        <Title level={3}>{t('Welcome.AccountCreated')}</Title>
        <Typography.Paragraph>{t('Welcome.UploadText')}</Typography.Paragraph>
        <Link to={UPLOAD_ROUTE_PATH}>
          <Button type="primary">{t('Welcome.Continue.button')}</Button>
        </Link>
      </InfoRectangle>
    </Page>
  )
}

export default Welcome
